// extracted by mini-css-extract-plugin
export var copyableField = "_p4-4";
export var customerBadge = "_p4-0";
export var customerInfoTitle = "_p4-2";
export var details = "_p4-1";
export var dropdownContainer = "_p4-5";
export var dropdownImage = "_p4-6";
export var editAssigneeForm = "_p4-a";
export var editButton = "_p4-3";
export var email = "_p4-7";
export var hidden = "_p4-d";
export var input = "_p4-8";
export var saveButton = "_p4-b";
export var shopifyIcon = "_p4-c";
export var suggestionBadge = "_p4-e";
export var suggestionText = "_p4-f";
export var username = "_p4-9";